import { DimensionUnitEnum } from '../enum/dimension-unit.enum';

export class Dimensions {
    static render(value: any, unit: DimensionUnitEnum): string {
        if (value === null) {
            return '';
        }
        if (unit === DimensionUnitEnum.CM) {
            const cm = Math.ceil(value);
            return `${cm} cm`;
        }
        const inches = Math.round(value * 10) / 10;
        return `${inches}"`;
    }

    static suffix(unit: DimensionUnitEnum): string {
        return unit === DimensionUnitEnum.CM ? 'cm' : '"';
    }

    static triplet(v1: any, v2: any, v3: any, unit: DimensionUnitEnum): string {
        return `${this.render(v1, unit)} × ${this.render(v2, unit)} × ${this.render(v3, unit)}`;
    }
}
